export const TIKTOK_PROVIDER_ID = 'tiktok';
const TIKTOK_AUTH_URL = 'https://www.tiktok.com/v2/auth/authorize/';
const TIKTOK_TOKEN_URL = 'https://open.tiktokapis.com/v2/oauth/token/';
const TIKTOK_DEFAULT_SCOPE = 'user.info.basic';
// TikTok Login Kit expects comma-separated scopes, not space-separated.
const serializeTikTokScope = (scope) => {
    if (scope === undefined || scope === null || scope === '') {
        return undefined;
    }
    if (Array.isArray(scope)) {
        return scope.filter(Boolean).join(',');
    }
    return scope;
};
export const buildTikTokOAuthConfig = (config) => {
    var _a, _b, _c, _d;
    return ({
        appId: config.clientKey,
        clientSecret: config.clientSecret,
        authorizationBaseUrl: TIKTOK_AUTH_URL,
        accessTokenEndpoint: TIKTOK_TOKEN_URL,
        redirectUrl: config.redirectUrl,
        responseType: 'code',
        pkceEnabled: (_a = config.pkceEnabled) !== null && _a !== void 0 ? _a : true,
        scope: (_c = serializeTikTokScope((_b = config.scope) !== null && _b !== void 0 ? _b : config.scopes)) !== null && _c !== void 0 ? _c : TIKTOK_DEFAULT_SCOPE,
        clientIdParamName: 'client_key',
        clientSecretParamName: 'client_secret',
        logsEnabled: (_d = config.logsEnabled) !== null && _d !== void 0 ? _d : false,
    });
};
export const buildTikTokLoginOptions = (options = {}) => {
    var _a;
    const scope = serializeTikTokScope((_a = options.scope) !== null && _a !== void 0 ? _a : options.scopes);
    return Object.assign(Object.assign({ providerId: TIKTOK_PROVIDER_ID }, (scope === undefined ? {} : { scope })), { state: options.state, codeVerifier: options.codeVerifier, redirectUrl: options.redirectUrl });
};
export const isTikTokOAuthResult = (result) => result.provider === 'oauth2' && result.result.providerId === TIKTOK_PROVIDER_ID;
export const asTikTokLoginResult = (result) => ({
    provider: 'tiktok',
    result: result.result,
});
//# sourceMappingURL=tiktok-provider.js.map